import { Component, computed, input } from '@angular/core'

@Component({
  selector: 'div[app-entity-field]',
  imports: [],
  template: `
    <label [for]="id()" class="form-label">{{ label() }}</label>
    <ng-content />
    @if (isInvalid()) {
      <div class='invalid-feedback'>{{ validationMessage() }}</div>
    }
  `,
  host: {
    class: 'mb-3',
  },
  styles: `
    .invalid-feedback {
      display: block;
    }
  `,
})
export class EntityFieldComponent {
  readonly id = input.required<string>()
  readonly label = input.required<string>()
  readonly validationMessage = input<string>()

  protected readonly isInvalid = computed(() => this.validationMessage() !== undefined)
}
